module.exports = __webpack_public_path__ + "img/REPIA_logo.968b5ebb.png";